import * as React from 'react';
import styled, { css } from 'styled-components';
import ActionText from '@liveauctioneers/caterwaul-components/lib/ActionText/ActionText';
import { faUsdCircle } from '@fortawesome/pro-regular-svg-icons/faUsdCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import { isUserAtLeastPartiallyRegistered } from '@/redux/modules/user';
import { ModalContext } from '@/redux/modules/modal';
import noop from '@/utils/noop';
import ShouldLogInContainer from '@/components/ShouldLogIn/ShouldLogInContainer';
import { useSelector } from 'react-redux';

type Props = {
    children?: React.ReactNode;
    className?: string;
    itemId: number;
    priceGatewayIcon?: boolean;
    runFunction?: Function;
    runFunctionArgument?: any[] | number | string | any;
};

/**
 *
 * 1) If logged out, show See Sold Price, else show sold price.
 * 2) Clicking See Sold Price prompts sign-up modal (the one with "What's It Worth?" title)
 * 3) See Sold Price appears on item cards and sold item page (at top and in bid box down toward the page)
 */
const ItemPriceGatewayContainer = (props: Props) => {
    const { children, className, itemId, priceGatewayIcon, runFunction = noop, runFunctionArgument } = props;

    const userAtLeastPartiallyRegistered = useSelector(isUserAtLeastPartiallyRegistered, isEqual);

    const modalContext: ModalContext = { id: itemId, type: 'see sold price' };

    const forceSignUp = !userAtLeastPartiallyRegistered;

    const content = userAtLeastPartiallyRegistered ? (
        children
    ) : (
        <span className={className}>
            <StyledActionText>
                <StyledFontAwesomeIcon $usePriceGatewayStyle={priceGatewayIcon} icon={faUsdCircle} />
                <FormattedMessage id="price_gateway_card" />
            </StyledActionText>
        </span>
    );

    return (
        <ShouldLogInContainer
            forceSignUp={forceSignUp}
            modalContext={modalContext}
            requireLogin={false}
            requireUserAtLeastPartiallyRegistered
            runFunction={runFunction}
            runFunctionArgument={runFunctionArgument}
        >
            {content}
        </ShouldLogInContainer>
    );
};

export default React.memo<Props>(ItemPriceGatewayContainer);

const PriceGatewayStyle = css`
    vertical-align: text-bottom;
`;

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)<{ $usePriceGatewayStyle: boolean }>`
    &&& {
        display: inline-block;
        height: 21px;
        margin-right: 5px;
        vertical-align: bottom;
        width: 21px !important;
    }

    ${({ $usePriceGatewayStyle }) => $usePriceGatewayStyle && PriceGatewayStyle}
`;

const StyledActionText = styled(ActionText)`
    text-decoration: underline;
    letter-spacing: 0.5px;
`;
